import {
  initialState,
  Actions,
  State,
  UPDATE_ONE_SURVEY,
  UPDATE_ONE_SURVEY_SUCCESS,
  UPDATE_ONE_SURVEY_ERROR,
  RESET_UPDATE_ONE_SURVEY,
} from "../../types/survey/update";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case UPDATE_ONE_SURVEY:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case UPDATE_ONE_SURVEY_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case UPDATE_ONE_SURVEY_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_UPDATE_ONE_SURVEY:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
